<template>
    <span>
        <template v-if="item.type=='String'" :class="item.class">
            {{getDataForPath(data,item.field)}}
</template>

<template v-else-if="item.type=='AddString'" :class="item.class">
     {{ item.AddString?item.AddString(data,item): AddString(data,item.field)}}
</template>
<template v-else-if="item.type=='Link'" :class="item.class">
   <a  href="javascript:void(0)" v-if="item.AddString(data,item)==0">  {{ item.AddString?item.AddString(data,item): AddString(data,item.field)}}</a>
     <a target="_blank" style="text-decoration: underline;color:#3C87F7" :href="item.AddString(data,item)" v-else>  {{ item.AddString?item.AddString(data,item): AddString(data,item.field)}}</a>
</template>

<template v-else-if="item.type=='AddLanguageString'" :class="item.class">
     {{AddLanguageString(data,item.field)}}
</template>

<template v-else-if="item.type=='Int'" :class="item.class">
     {{getDataForPath(data,item.field)}}
</template>

<template v-else-if="item.type=='DateTime'" :class="item.class">
     {{getDataForPath(data,item.field)}}
</template>

<template v-else-if="item.type=='Select'" :class="item.class">
     {{getDataForPath(data,item.field) | toSelect(item.forSelectStoreName)}}
</template>

<template v-else-if="item.type=='Boolean'" :class="item.class">
     {{getDataForPath(data,item.field) | toSelect(item.forSelectStoreName)}}
</template>

<template v-else-if="item.type=='StringIcon'" :class="item.class">
    <div style="display:flex;align-items: center;">
        {{ item.AddString?item.AddString(data,item): AddString(data,item.field)}}
        <!-- <img :src="item.imgUrl" alt="" /> -->
        <i v-if="item.isShowIcon(data)" :class="item.iconClassName" :style="item.iconStyle"></i>
    </div>

</template>
<template v-else-if="item.type=='Image'" :class="item.class">
     <!-- <img :src="(Urlpath == '/' ? '' : Urlpath) +getDataForPath(data,item.field)" :class="item.class" :style="{display:getDataForPath(data,item.field)?'':'none'}"> -->


   <el-popover
    placement="right"
    title=""
    trigger="hover">
    <img :src="(Urlpath == '/' ? '' : Urlpath) +getDataForPath(data,item.field)" />
    <img slot="reference" :src="(Urlpath == '/' ? '' : Urlpath) +getDataForPath(data,item.field)"   style="max-height: 100px;max-width:100px">
   </el-popover>


</template>

<template v-else-if="item.type=='WebImage'" :class="item.class">
     <!-- <img :src="(Urlpath == '/' ? '' : Urlpath) +getDataForPath(data,item.field)" :class="item.class" :style="{display:getDataForPath(data,item.field)?'':'none'}"> -->


   <el-popover
    placement="right"
    title=""
    trigger="hover">
    <img :src="getDataForPath(data,item.field)" />
    <img slot="reference" :src="getDataForPath(data,item.field)"   style="max-height: 100px;max-width:100px">
   </el-popover>


</template>


<template v-else-if="item.type=='Input'" :class="item.class">
     <el-input   v-model="data[item.field]"
                       ref="input" :disabled="!!item.IsNotEdit"
                       :placeholder="item.placeholder" @change="function(v){
                                if(item.OnChange){
                                    item.OnChange(v,item,data)
                                }
                        }">

                        <i v-if="item.SuffixText" slot="suffix" >{{item.SuffixText}}</i>
                        <i v-if="item.PrefixText" slot="prefix" {{item.PrefixText}}</i>
                        <i v-if="item.PrependText" slot="prepend" >{{item.PrependText}}</i>
                        <i v-if="item.AppendText" slot="append" >{{item.AppendText}}</i>

           </el-input>

                <div class="bs-example bs-example-bg-classes"
                     style="color:red"
                     v-bind:class="{ show: item.isCheck }">{{item.error}}</div>
</template>



<div v-else-if="item.type=='Html'" v-html="getDataForPath(data,item.field)" :class="item.class">

</div>
    </span>
    </template>

<script>
    var isType = false;
    import gets from '@/model/language.js'
    export default {
        props: ['data', 'item'],
        data() {
            return {
                 $Urlpath: window._$Urlpath,
			    Urlpath: window._$Urlpath,
            }
        },
        created() {
            var boo = false;
        },
        computed: {

        },
        methods: {
            gets: gets,
            getDataForPath(d, path) {
                var todata = d;
                var ps = path.split('.')
                for (var i of ps) {
                    try {
                        todata = todata[i];
                    } catch (error) {
                        return '';
                    }
                }
                return todata;
            },
            AddString(c, fieldName) {
                var ds = (fieldName + "").split(',')
                var str = '';
                for (var index = 0; index < ds.length; index++) {
                    var element = ds[index];
                    str += this.getDataForPath(c, element)
                }
                return str;
            },
            AddLanguageString(c, fieldName) {
                var ds = (fieldName + "").split(',')
                var str = this.getDataForPath(c, ds[0]);
                if (ds.length > 0) {
                    str += "(" + this.getDataForPath(c, ds[1]) + ")"
                }
                return str;
            },
        },
    }

</script>




// WEBPACK FOOTER //
// table_value.vue?4bcf42c8